import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Modal,
  Form,
  TextInput,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  ButtonsWrapper,
  Button,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { TemplateTasksWrapper, DeleteContainer, AddButton } from './project-task-templates.styles';

interface ModalProps {
  data?: any;
  onFinish: (values: any) => void;
  onDelete: () => void;
  onClose: () => void;
}

export const ProjectTaskTemplateModal: React.FC<ModalProps> = ({
  data,
  onFinish,
  onDelete,
  onClose,
}) => {
  const { t } = useTranslation('settings');

  return (
    <Modal
      isOpened
      title={
        data
          ? t('companySettings.labels.editTemplate')
          : t('companySettings.buttons.addNewTaskTemplate')
      }
      onClose={onClose}
    >
      <Form layout="vertical" initialValues={{ taskNames: [''], ...data }} onFinish={onFinish}>
        <Form.Item
          name="templateName"
          label={t('companySettings.labels.templateName')}
          rules={[
            { required: true, message: t('companySettings.exceptions.requiredTemplateName') },
          ]}
        >
          <TextInput placeholder="Painting" maxLength={50} />
        </Form.Item>
        <Form.List name="taskNames">
          {(fields: any, { add, remove }: any) => (
            <TemplateTasksWrapper>
              {fields.map((field: any) => (
                <DeleteContainer key={field.key}>
                  <Form.Item
                    style={{ transition: 'none' }}
                    name={field.name}
                    label={t('companySettings.labels.taskName')}
                    rules={[
                      {
                        required: true,
                        message: t('companySettings.exceptions.requiredTaskName'),
                      },
                    ]}
                  >
                    <TextInput placeholder="Paint the door" maxLength={50} />
                  </Form.Item>
                  {fields.length > 1 && (
                    <div>
                      <Icon
                        icon={ICONS.trash}
                        color={PLATFORM_THEME_COLORS.tone.red}
                        rightMargin={false}
                        size={22}
                        onClick={() => remove(field.name)}
                      />
                    </div>
                  )}
                </DeleteContainer>
              ))}
              <AddButton
                type="text"
                icon={ICONS.plus}
                iconColor={PLATFORM_THEME_COLORS.primary.blue}
                onClick={() => add()}
              >
                {t('companySettings.buttons.addTask')}
              </AddButton>
            </TemplateTasksWrapper>
          )}
        </Form.List>
        <ButtonsWrapper marginTop={15}>
          <Button type="primary" htmlType="submit">
            {data ? t('common:buttons.save') : t('common:buttons.add')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
          {data && (
            <Button type="text" onClick={onDelete}>
              <Typography fontColor={PLATFORM_THEME_COLORS.tone.red}>
                {t('companySettings.buttons.deleteTemplate')}
              </Typography>
            </Button>
          )}
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};
